module.exports = __webpack_public_path__ + "img/hospital-building.573ab002.svg";